import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

const CarManagement = () => {
    const [cars, setCars] = useState([]);
    const [editingCarId, setEditingCarId] = useState(null);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        fetchCars();
    }, []);

    const fetchCars = async () => {
        try {
            const response = await axios.get('https://api.mitradingjp.com/api.php/cars');
            setCars(response.data);
        } catch (error) {
            console.error('Error fetching cars:', error);
        }
    };

    const handleEdit = (car) => {
        setEditingCarId(car.id);
        setFormData(car);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://api.mitradingjp.com/api.php/cars/${id}`);
            fetchCars();
        } catch (error) {
            console.error('Error deleting car:', error);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            await axios.put(`https://api.mitradingjp.com/api.php/cars/${editingCarId}`, formData);
            setEditingCarId(null);
            fetchCars();
        } catch (error) {
            console.error('Error updating car:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, images: e.target.files });
    };

    return (
        <div className="container mt-5">
            <h1>Car Management</h1>
            <table className="table">
                <thead>
                    <tr>
                        <th>Maker</th>
                        <th>Model</th>
                        <th>Year</th>
                        <th>Price</th>
                        <th>Country</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {cars.map((car) => (
                        <React.Fragment key={car.id}>
                            <tr>
                                <td>{car.maker}</td>
                                <td>{car.model}</td>
                                <td>{car.year}</td>
                                <td>{car.price}</td>
                                <td>{car.country}</td>
                                <td>
                                    <button className="btn btn-primary btn-sm" onClick={() => handleEdit(car)}>Edit</button>
                                    <button className="btn btn-danger btn-sm ml-2" onClick={() => handleDelete(car.id)}>Delete</button>
                                </td>
                            </tr>
                            {editingCarId === car.id && (
                                <tr>
                                    <td colSpan="6">
                                        <form onSubmit={handleUpdate}>
                                            <div className="form-row">
                                                <div className="form-group col-md-3">
                                                    <label>Maker</label>
                                                    <input type="text" className="form-control" name="maker" value={formData.maker} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Model</label>
                                                    <input type="text" className="form-control" name="model" value={formData.model} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label>Year</label>
                                                    <input type="number" className="form-control" name="year" value={formData.year} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label>Price</label>
                                                    <input type="number" className="form-control" name="price" value={formData.price} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label>Country</label>
                                                    <input type="text" className="form-control" name="country" value={formData.country} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-3">
                                                    <label>Mileage</label>
                                                    <input type="number" className="form-control" name="mileage" value={formData.mileage} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Fuel</label>
                                                    <input type="text" className="form-control" name="fuel" value={formData.fuel} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label>Transmission</label>
                                                    <input type="text" className="form-control" name="transmission" value={formData.transmission} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label>Drive</label>
                                                    <input type="text" className="form-control" name="drive" value={formData.drive} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label>Color</label>
                                                    <input type="text" className="form-control" name="color" value={formData.color} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-3">
                                                    <label>Stock ID</label>
                                                    <input type="text" className="form-control" name="stock_id" value={formData.stock_id} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>VIN</label>
                                                    <input type="text" className="form-control" name="vin" value={formData.vin} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Body Type</label>
                                                    <input type="text" className="form-control" name="body_type" value={formData.body_type} onChange={handleChange} />
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <label>Features</label>
                                                    <input type="text" className="form-control" name="features" value={formData.features} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group col-md-6">
                                                    <label>Images</label>
                                                    <input type="file" className="form-control" name="images" onChange={handleFileChange} multiple />
                                                </div>
                                            </div>
                                            <button type="submit" className="btn btn-success">Update</button>
                                            <button type="button" className="btn btn-secondary ml-2" onClick={() => setEditingCarId(null)}>Cancel</button>
                                        </form>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CarManagement;